import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class FormApi {
    getInstitutionForms(config) {
        return axios.get(BASE_URL + `/admin/forms/institution`, config)
    }
    getFormDetails(formId, config) {
        return axios.get(BASE_URL + `/admin/forms/${formId}`, config)
    }
    addForm(formData, config) {
        return axios.post(BASE_URL + "/admin/forms/addForm", formData, config)
    }
    updateForm(formId, formData, config) {
        return axios.put(BASE_URL + `/admin/forms/updateForm/${formId}`, formData, config)
    }
    deleteForm(formId, config) {
        return axios.delete(BASE_URL + `/admin/forms/deleteForm/${formId}`, config)
    }
    getInstitutionMenuList(config) {
        return axios.get(BASE_URL + "/admin/institution/menu-list", config)
    }
    getProgramsByInstitution(institutionCode, config) {
        return axios.get(BASE_URL + `/admin/forms/programs/${institutionCode}`, config)
    }
    getCoursesByProgram(programId, config) {
        return axios.get(BASE_URL + `/admin/forms/courses/${programId}`, config)
    }

    getAllResponses(config) {
        return axios.get(BASE_URL + "/admin/formResponses/all", config)
    }

    getResponseById(responseId, config) {
        return axios.get(BASE_URL + `/admin/formResponses/${responseId}`, config)
    }
}

const formApi = new FormApi()
export default formApi